const rolePaths = {
  admin: '/adminApplication',
  student: '/student',
  reviewer: '/reviewer',
  approver: '/approver',
  superAdmin: '/dashboard',
  finance: '/finance',
  'al-kauser Admin': '/admin',
  vendor: '/partner',
  'record-keeper': '/record-keeper',
};

export const getRedirectPath = (role) => {
  return rolePaths[role] || '/';
};

/**
 * True if the user is already within their role's app (refresh should not redirect to base).
 */
export const isAlreadyOnRolePath = (pathname, role) => {
  const base = rolePaths[role];
  if (!base || base === '/') return false;
  return pathname === base || pathname.startsWith(base + '/');
};